import apiClient from "@/shared/api/apiClient3";

export const getReferenceListByCodes = async (params) => {
  try {
    const { data } = await apiClient.post(
      "/directory/batch/",
      {
        ...params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("[directory/references] getReferenceListByCodes", e);
  }
};
